import RequestService from './request-service';

/**
 * Service for getting betslipGroup from code
 */
export default class BetslipCheckerService extends RequestService {
  constructor() {
    super();
    this.endpoint = process.env.VUE_APP_IS_AGENT ? this.$config.endpoints.checkBetslipAgent : this.$config.endpoints.checkBetslip;
    this.method = 'get';

    this.getParams = {
      Code: '',
      Culture: APP_SETTINGS.player.language,
    };

    this.headers = this.$config.authorizationHeaders;
    this.addHeader('ExternalUserID', APP_SETTINGS.player.id);
  }
}
